import React from 'react';
import { Edit, SimpleForm } from 'react-admin';
import { FormPageTitle, FormToolbar } from '@/components/shell';
import { LicenseFields } from './LicenseFields';

const BACK_TO = '/system?tab=licenses';

interface LicenseFormValues {
  id: number | string;
  licenseName: string;
  serverIds?: string[];
  servers?: { id: number | string }[];
}

const transform = (data: LicenseFormValues) => ({
  id: data.id,
  licenseName: data.licenseName,
  serverId: data.serverIds || (data.servers || []).map((s) => s.id),
});

export const LicenseEdit = () => (
  <Edit mutationMode="pessimistic" transform={transform} actions={<FormPageTitle mode="edit" />}>
    <SimpleForm toolbar={<FormToolbar backTo={BACK_TO} showDelete />}>
      <LicenseFields />
    </SimpleForm>
  </Edit>
);
